
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { QuestionModel } from './Entities.GormCrm.Question';
import { Model, ModelProperty } from 'models/Model';


export class QuestionReplyOptionModel extends Model<QuestionReplyOptionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'questionReplyOption.property.id', isHidden: true },
		{ name: 'questionId', type: 'guid', languageString: 'questionReplyOption.property.questionId' },
		{ name: 'replyText', type: 'string', languageString: 'questionReplyOption.property.replyText' },
		{ name: 'sortOrder', type: 'number', languageString: 'questionReplyOption.property.sortOrder' },
		{ name: 'question', type: 'QuestionModel', languageString: 'questionReplyOption.property.question', isHidden: true, isObject: true, new: () => { return new QuestionModel }, properties: () => { return QuestionModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public questionId?: string;
	public replyText: string;
	public sortOrder: number;
	public question?: QuestionModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.questionId = undefined;
		this.replyText = '';
		this.sortOrder = 0;
		this.question = undefined;
		
	}
	getProperties(){
		return QuestionReplyOptionModel.classProperties;
	}
}

